import { loadStripe } from "@stripe/stripe-js";

// Stripe promise loaded once at module level
export const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_KEY ?? ""
);
